export default function Loader() {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="animate-spin h-16 w-16 border-4 border-gray-300 border-t-gray-900 rounded-full"></div>
    </div>
  );
}
